import { Injectable } from '@angular/core';
import { NbAuthJWTToken, NbTokenService } from '@nebular/auth';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private apiService: ApiService, public tokenService: NbTokenService) { }

  updateToken(entidad: number, perfil: number, time: number): Observable<boolean> {
    return this.apiService
      .post<string>('api/Account/UpdateToken', { iIDEntidad: entidad, iIDPerfil: perfil, timeExpire: time })
      .pipe(
        map(token => {
          if (token) {
            this.tokenService.set(new NbAuthJWTToken(token, 'email'));
            return true;
          }
          return false;
        })
      );
  }

  check(): Observable<boolean> {
    return this.apiService.getWithResponse('/api/Account/Check').pipe(
      map(x => x.ok),
      catchError(() => of(false))
    );
  }
}